<div class="shipname">{{shipname}}</div>
